import Vue from 'vue';
import Router from 'vue-router';
import MenuPrincipal from '@/components/MenuPrincipal';

const Registro = () => import('@/components/Registro');
const Reimprimir_Registro = () => import('@/components/Reimprimir_Registro');
const Presentar = () => import('@/components/Presentar');
const Login = () => import('@/components/Login');
const Imprimir_Registro = () => import('@/components/Imprimir_Registro');
const Imprimir_Boleta_Examen = () => import('@/components/Imprimir_Boleta_Examen');
const Datos_Alumno = () => import('@/components/Datos_Alumno');
const Examenes = () => import('@/components/Examenes/Examenes');
const Instrucciones_Kuder = () => import('@/components/Examenes/Kuder/Instrucciones');
const Preguntas_Kuder = () => import('@/components/Examenes/Kuder/Preguntas');
const Instrucciones_Mmpi2 = () => import('@/components/Examenes/Mmpi2/Instrucciones');
const Preguntas_Mmpi2 = () => import('@/components/Examenes/Mmpi2/Preguntas');
const Instrucciones_Catell = () => import('@/components/Examenes/Catell/Instrucciones');
const Preguntas_Catell = () => import('@/components/Examenes/Catell/Preguntas');
const Instrucciones_CAQ = () => import('@/components/Examenes/CAQ/Instrucciones');
const Preguntas_CAQ = () => import('@/components/Examenes/CAQ/Preguntas');
const Instrucciones_Terman = () => import('@/components/Examenes/Terman/Instrucciones');
const Preguntas_Terman = () => import('@/components/Examenes/Terman/Preguntas');
const Instrucciones_MmpiA = () => import('@/components/Examenes/MmpiA/Instrucciones');
const Preguntas_MmpiA = () => import('@/components/Examenes/MmpiA/Preguntas');
const Instrucciones_Edwards = () => import('@/components/Examenes/Edwards/Instrucciones')
const Preguntas_Edwards = () => import('@/components/Examenes/Edwards/Preguntas')
const Entrevista = () => import('@/components/Examenes/Entrevista/Entrevista');
const Dibujos = () => import('@/components/Examenes/Dibujos/Dibujos');
const Instrucciones_16PF = () => import('@/components/Examenes/16PF/Instrucciones');
const Preguntas_16PF = () => import('@/components/Examenes/16PF/Preguntas');
const Instrucciones_O_V = () => import('@/components/Examenes/OrientacionVocacional/Instrucciones');
const Preguntas_O_V = () => import('@/components/Examenes/OrientacionVocacional/Preguntas');
const Instrucciones_Honney = () => import('@/components/Examenes/Honney/Instrucciones');
const Preguntas_Honney = () => import('@/components/Examenes/Honney/Preguntas');
const Instrucciones_depBeck = () => import('@/components/Examenes/DepresionBeck/Instrucciones');
const Preguntas_depBeck = () => import('@/components/Examenes/DepresionBeck/Preguntas');
const Instrucciones_anBeck = () => import('@/components/Examenes/AnsiedadBeck/Instrucciones');
const Preguntas_anBeck = () => import('@/components/Examenes/AnsiedadBeck/Preguntas');
const Instrucciones_eynsek = () => import('@/components/Examenes/Eynsek/Instrucciones');
const Preguntas_eynsek = () => import('@/components/Examenes/Eynsek/Preguntas');

Vue.use(Router)

export default new Router({
  routes: [
    {path: '/',name: 'MenuPrincipal',component: MenuPrincipal, children:[
    	{path: 'registro',name: 'Registro',component: Registro},
        {path: 'reimprimir_registro',name: 'Reimprimir_Registro',component: Reimprimir_Registro},
    	{path: 'presentar',name: 'Presentar',component: Presentar},
        {path: 'login',name: 'Login',component: Login},
    	{path: 'datos_alumno',name: 'Datos_Alumno',component: Datos_Alumno},
        {path: 'examenes',name: 'Examenes',component: Examenes},
	]},
	{path: '/imprimir_registro/:folio',name: 'Imprimir_Registro',component: Imprimir_Registro},
    {path: '/imprimir_boleta_examen',name: 'Imprimir_Boleta_Examen',component: Imprimir_Boleta_Examen},
    {path: '/examenes/kuder_v/instrucciones',name: 'kuder_v_instrucciones',component: Instrucciones_Kuder},
    {path: '/examenes/kuder_v/preguntas',name: 'kuder_v_preguntas',component: Preguntas_Kuder},
    {path: '/examenes/mmpi2/instrucciones',name: 'mmpi2_instrucciones',component: Instrucciones_Mmpi2},
    {path: '/examenes/mmpi2/preguntas',name: 'mmpi2_preguntas',component: Preguntas_Mmpi2},
    {path: '/examenes/catell/instrucciones',name: 'catell_instrucciones',component: Instrucciones_Catell},
    {path: '/examenes/catell/preguntas',name: 'catell_preguntas',component: Preguntas_Catell},
    {path: '/examenes/caq/instrucciones',name: 'caq_instrucciones',component: Instrucciones_CAQ},
    {path: '/examenes/caq/preguntas',name: 'caq_preguntas',component: Preguntas_CAQ},
    {path: '/examenes/terman/instrucciones/:serie',name: 'terman_instrucciones',component: Instrucciones_Terman},
    {path: '/examenes/terman/preguntas/:serie',name: 'terman_preguntas',component: Preguntas_Terman},
    {path: '/examenes/mmpia/instrucciones',name: 'mmpia_instrucciones',component: Instrucciones_MmpiA},
    {path: '/examenes/mmpia/preguntas',name: 'mmpia_preguntas',component: Preguntas_MmpiA},
    {path: '/examenes/edwards/instrucciones',name: 'edwards_instrucciones',component: Instrucciones_Edwards},
    {path: '/examenes/edwards/preguntas',name: 'edwards_preguntas',component: Preguntas_Edwards},
    {path: '/examenes/entrevista',name: 'entrevista',component: Entrevista},
    {path: '/examenes/dibujos',name: 'dibujos',component: Dibujos},
    {path: '/examenes/16pf/instrucciones',name: '16pf_instrucciones',component: Instrucciones_16PF},
    {path: '/examenes/16pf/preguntas',name: '16pf_preguntas',component: Preguntas_16PF},
    {path: '/examenes/o_v/instrucciones',name: 'o_v_instrucciones',component: Instrucciones_O_V},
    {path: '/examenes/o_v/preguntas',name: 'o_v_preguntas',component: Preguntas_O_V},
    {path: '/examenes/honney/instrucciones',name: 'honney_instrucciones',component: Instrucciones_Honney},
    {path: '/examenes/honney/preguntas',name: 'honney_preguntas',component: Preguntas_Honney},
    {path: '/examenes/depBeck/instrucciones',name: 'depBeck_instrucciones',component: Instrucciones_depBeck},
    {path: '/examenes/depBeck/preguntas',name: 'depBeck_preguntas',component: Preguntas_depBeck},
    {path: '/examenes/anBeck/instrucciones',name: 'anBeck_instrucciones',component: Instrucciones_anBeck},
    {path: '/examenes/anBeck/preguntas',name: 'anBeck_preguntas',component: Preguntas_anBeck},
    {path: '/examenes/eynsek/instrucciones',name: 'eynsek_instrucciones',component: Instrucciones_eynsek},
    {path: '/examenes/eynsek/preguntas',name: 'eynsek_preguntas',component: Preguntas_eynsek},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js